import toast from 'react-hot-toast';

export interface ToastOptions {
  duration?: number;
  description?: string;
}

export const useToast = () => {
  const showSuccess = (message: string, options?: ToastOptions) => {
    toast.success(message, {
      duration: options?.duration || 3000,
    });
  };

  const showError = (message: string, options?: ToastOptions) => {
    toast.error(message, {
      duration: options?.duration || 5000,
    });
  };

  const showWarning = (message: string, options?: ToastOptions) => {
    toast(message, {
      duration: options?.duration || 4000,
      icon: '⚠️',
      style: {
        background: '#ffffff',
        color: '#f59e0b',
        border: '2px solid #f59e0b',
        borderRadius: '8px',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
        fontSize: '14px',
        padding: '12px 16px',
      },
      iconTheme: {
        primary: '#f59e0b',
        secondary: '#ffffff',
      },
    });
  };

  const showInfo = (message: string, options?: ToastOptions) => {
    toast(message, {
      duration: options?.duration || 4000,
      icon: 'ℹ️',
      style: {
        background: '#ffffff',
        color: '#3b82f6',
        border: '2px solid #3b82f6',
        borderRadius: '8px',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
        fontSize: '14px',
        padding: '12px 16px',
      },
      iconTheme: {
        primary: '#3b82f6',
        secondary: '#ffffff',
      },
    });
  };

  const showLoading = (message: string, options?: ToastOptions) => {
    return toast.loading(message, {
      duration: options?.duration || 4000,
      style: {
        background: '#ffffff',
        color: '#6366f1',
        border: '2px solid #6366f1',
        borderRadius: '8px',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
        fontSize: '14px',
        padding: '12px 16px',
      },
    });
  };

  const showDefault = (message: string, options?: ToastOptions) => {
    toast(message, {
      duration: options?.duration || 4000,
      style: {
        background: '#ffffff',
        color: '#6b7280',
        border: '2px solid #6b7280',
        borderRadius: '8px',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
        fontSize: '14px',
        padding: '12px 16px',
      },
    });
  };

  const dismiss = () => {
    toast.dismiss();
  };

  return {
    success: showSuccess,
    error: showError,
    warning: showWarning,
    info: showInfo,
    loading: showLoading,
    default: showDefault,
    dismiss,
  };
};
